// extracted by mini-css-extract-plugin
export default {"headerBackdrop":"Photos_headerBackdrop__3NAO9","slideshow":"Photos_slideshow__sZe37","slideshowLabel":"Photos_slideshowLabel__R93at","imgWrapper":"Photos_imgWrapper__YeTQj"};